module.exports = __webpack_public_path__ + "img/blue_115.b7e2aa6d.png";